import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CheckList from '@/components/CheckList.vue';
import CharacterSheetModifier from './CharacterSheetModifier.vue';
import CharacterSheetTweaker from './CharacterSheetTweaker.vue';
import CharacterSheetExpansionFeatures from './CharacterSheetExpansionFeatures.vue';
import { isEmpty } from 'lodash';
let CharacterSheetSuperiority = class CharacterSheetSuperiority extends Vue {
    constructor() {
        super(...arguments);
        this.isEmpty = isEmpty;
    }
    handleUpdateSuperiorityDice(superiorityDiceUsed) {
        this.$emit('updateCharacter', { currentStats: { superiorityDiceUsed } });
    }
};
__decorate([
    Prop(Object)
], CharacterSheetSuperiority.prototype, "superiority", void 0);
__decorate([
    Prop(Object)
], CharacterSheetSuperiority.prototype, "tweaks", void 0);
CharacterSheetSuperiority = __decorate([
    Component({
        components: {
            CheckList,
            CharacterSheetModifier,
            CharacterSheetTweaker,
            CharacterSheetExpansionFeatures
        }
    })
], CharacterSheetSuperiority);
export default CharacterSheetSuperiority;
